export type IconPos = 'left' | 'right';
export type IconSize = 'small' | 'medium' | 'large';

export class IconFontAwesome {
  static readonly A = 'a';
  static readonly ALIGN_LEFT = 'align-left';
  static readonly ARROW_DOWN_SHORT_WIDE = 'arrow-down-short-wide';
  static readonly BARCODE = 'barcode';
  static readonly BARS_STAGGERED = 'bars-staggered';
  static readonly BELL = 'bell';
  static readonly BUS_SIMPLE = 'bus-simple';
  static readonly CALENDAR = 'calendar';
  static readonly CIRCLE_DOT = 'circle-dot';
  static readonly CIRCLE_XMARK = 'circle-xmark';
  static readonly CLIPBOARD = 'clipboard';
  static readonly CLOCK = 'clock';
  static readonly CODE = 'code';
  static readonly CODE_COMMIT = 'code-commit';
  static readonly CODE_FORK = 'code-fork';
  static readonly COMMENT = 'comment';
  static readonly COMMENTS = 'comments';
  static readonly DOOR_OPEN = 'door-open';
  static readonly ENVELOPE = 'envelope';
  static readonly EYE = 'eye';
  static readonly FILE = 'file';
  static readonly FLOPPY_DISK = 'floppy-disk';
  static readonly G = 'g';
  static readonly GAUGE = 'gauge';
  static readonly GEARS = 'gears';
  static readonly GEM = 'gem';
  static readonly GRIP_LINES = 'grip-lines';
  static readonly GRIP_VERTICAL = 'grip-vertical';
  static readonly HAND = 'hand';
  static readonly HEADING = 'heading';
  static readonly HILL_AVALANCHE = 'hill-avalanche';
  static readonly HOUSE = 'house';
  static readonly IMAGE = 'image';
  static readonly LIFE_RING = 'life-ring';
  static readonly LINK = 'link';
  static readonly LOCATION_ARROW = 'location-arrow';
  static readonly LOCATION_DOT = 'location-dot';
  static readonly MAGNIFYING_GLASS = 'magnifying-glass';
  static readonly MAP_LOCATION_DOT = 'map-location-dot';
  static readonly PEN_TO_SQUARE = 'pen-to-square';
  static readonly PENCIL = 'pencil';
  static readonly PHONE = 'phone';
  static readonly RECTANGLE_AD = 'rectangle-ad';
  static readonly RECTANGLE_LIST = 'rectangle-list';
  static readonly RECTANGLE_XMARK = 'rectangle-xmark';
  static readonly RIGHT_LEFT = 'right-left';
  static readonly SIGNATURE = 'signature';
  static readonly SITEMAP = 'sitemap';
  static readonly SLIDERS = 'sliders';
  static readonly SQUARE_CHECK = 'square-check';
  static readonly STAR = 'star';
  static readonly STOPWATCH = 'stopwatch';
  static readonly STREET_VIEW = 'street-view';
  static readonly T = 't';
  static readonly TAG = 'tag';
  static readonly TEMPERATURE_LOW = 'temperature-low';
  static readonly TEXT_HEIGHT = 'text-height';
  static readonly TOGGLE_OFF = 'toggle-off';
  static readonly TOGGLE_ON = 'toggle-on';
  static readonly TRAILER = 'trailer';
  static readonly TRASH = 'trash';
  static readonly TRUCK_ARROW_RIGHT = 'truck-arrow-right';
  static readonly TRUCK_DROPLET = 'truck-droplet';
  static readonly TRUCK_FAST = 'truck-fast';
  static readonly TRUCK_LOADING = 'truck-loading';
  static readonly TRUCK_MONSTER = 'truck-monster';
  static readonly TRUCK_RAMP_BOX = 'truck-ramp-box';
  static readonly USER_ASTRONAUT = 'user-astronaut';
  static readonly WIFI = 'wifi';
}
